/**
 * WebSocket Store Exports
 *
 * This file re-exports the modular stores for direct usage.
 * The facade pattern has been removed to simplify the architecture.
 */

import { useConnectionStore as connectionStore } from './stores/connection.store';

// Re-export all stores directly
export {
  useConnectionStore,
  ConnectionStatus,
} from './stores/connection.store';
export { useSubscriptionStore } from './stores/subscription.store';
export { useMetricsStore } from './stores/metrics.store';
export { useWebSocketUIStore } from './stores/ui.store';

// Re-export types
export type {
  WebSocketMessage,
  WebSocketMetrics,
} from './stores/metrics.store';
export type {
  WebSocketChannel,
  WebSocketSubscription,
} from './stores/subscription.store';

// Simple selectors for commonly used values
export const useConnectionStatus = () =>
  connectionStore((state) => state.status);
export const useIsConnected = () =>
  connectionStore((state) => state.isConnected);
